/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeleteTeamNoteRequest
 */
export interface DeleteTeamNoteRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteTeamNoteRequest
   */
  noteId: string;
}

/**
 * Check if a given object implements the DeleteTeamNoteRequest interface.
 */
export function instanceOfDeleteTeamNoteRequest(
  value: object,
): value is DeleteTeamNoteRequest {
  if (!("noteId" in value) || value["noteId"] === undefined) return false;
  return true;
}

export function DeleteTeamNoteRequestFromJSON(
  json: any,
): DeleteTeamNoteRequest {
  return DeleteTeamNoteRequestFromJSONTyped(json, false);
}

export function DeleteTeamNoteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DeleteTeamNoteRequest {
  if (json == null) {
    return json;
  }
  return {
    noteId: json["noteId"],
  };
}

export function DeleteTeamNoteRequestToJSON(json: any): DeleteTeamNoteRequest {
  return DeleteTeamNoteRequestToJSONTyped(json, false);
}

export function DeleteTeamNoteRequestToJSONTyped(
  value?: DeleteTeamNoteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    noteId: value["noteId"],
  };
}
